<li
  #dom
  [attr.data-checked]="checked"
  [style]="checklistItemStyles"
  data-component-type="checklist-item"
>
  <div [style]="checkboxContainerStyles">
    <div
      [style]="checkboxStyles"
      [style.cursor]="canToggle ? 'pointer' : null"
      (mousedown)="$event.preventDefault()"
      (click)="onToggle($event)"
      [rtTooltip]="tooltipMessage"
      [rtTooltipEnabled]="!canToggle"
      class="rt-pm-checkbox"
    ></div>
  </div>
  <div #content></div>
</li>
